import { useState, useEffect } from "react";
import "./CookieConsent.css";

const STORAGE_KEY = "tq-cookie-consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="ck-backdrop" role="dialog" aria-modal="true" aria-label="Cookie consent">
      <div className="ck-bar">
        <div className="ck-left">
          <div className="ck-label">COOKIES</div>
          <p className="ck-text">
            Używamy plików cookie do analizy ruchu i poprawy działania strony.
            Niezbędne cookies są zawsze aktywne.{" "}
            <button className="ck-toggle" onClick={() => setExpanded(p => !p)}>
              {expanded ? "Zwiń ▲" : "Szczegóły ▼"}
            </button>
          </p>
          {expanded && (
            <ul className="ck-details">
              <li>
                <span className="ck-dot ck-dot--required" />
                <strong>Niezbędne</strong> — sesja, preferencje motywu i języka. Zawsze aktywne.
              </li>
              <li>
                <span className="ck-dot ck-dot--analytics" />
                <strong>Analityczne</strong> — anonimowe dane o ruchu (Google Analytics).
              </li>
            </ul>
          )}
        </div>
        <div className="ck-actions">
          <button className="ck-btn ck-btn--reject" onClick={reject}>
            Odrzuć
          </button>
          <button className="ck-btn ck-btn--accept" onClick={accept}>
            Akceptuj wszystkie
          </button>
        </div>
      </div>
    </div>
  );
}
